import { dapCommonLang } from '~/data/common/lang/global'
export let dapLangGlobal: object = Object.freeze(deepMerge(dapCommonLang, {
  serviceName: {
    ja: 'ジャパンサーチ',
    en: 'Japan Search',
  },
  linkToSource: {
    ja: '収録データベースで表示',
    en: 'Open in Source Archives',
  },
  openInSource: {
    ja: '収録元データベースで開く',
    en: 'Open in Source Archives',
  },
  openInDatabase: {
    ja: 'データベースを開く',
    en: 'Access this database',
  },
  contact: {
    name: {
      ja: 'ジャパンサーチ事務局',
      en: 'Japan Search Office',
    },
    mail: {
      ja: 'ml-renkei@ndl.go.jp',
      en: 'ml-renkei@ndl.go.jp',
    },
  },
  quickSearchLink: {
    ja: 'ジャパンサーチ内を検索',
    en: 'Search',
  },
  metadata: {
    common: {
      label: {
        ja: 'ジャパンサーチ共通メタデータ',
        en: 'Japan Search Common Meta data',
      },
    },
  },
  datasource: {
    ja: '収録されているデータベース',
    en: 'Data source',
  },
  db: {
    recordCount: {
      ja: 'レコード数',
      en: 'Record',
    },
  },

  // 公開状態の変更
  publicationChange: {
    displayed: {
      ja: '{}上で表示され、検索が可能となります。APIからも検索・取得が可能です。',
      en: 'Displayed and searchable on {}. Also searchable and retrievable via API.',
    },
  },

  // 統計
  stats: {
    database: {
      category: {
        ja: '分野',
        en: 'Area',
      }
    }
  },
}))
